var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#898B91",
    fillRule: "evenodd",
    d: "M18 11.5a6 6 0 016 6 .5.5 0 01-.5.5H17a.5.5 0 01-.5-.5 8.934 8.934 0 00-1.325-4.681.5.5 0 01.206-.711A5.95 5.95 0 0118 11.5zM7.5 10a7.5 7.5 0 017.5 7.5.5.5 0 01-.5.5H.5a.5.5 0 01-.5-.5A7.5 7.5 0 017.5 10zm10.444-6.5a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5zM7.5 0a4.75 4.75 0 110 9.5 4.75 4.75 0 010-9.5z"
  })));
}
export default SvgTwoPeople;